module.exports = __webpack_public_path__ + "static/media/recipients-sample-csv.889641d5.csv";